import "./portfolio.scss";
import { Link } from "react-router-dom";
import data from "../../data";

export default function Portfolio() {

 
  return (
    <div className="portfolio" id="portfolio">
    <br/>
      <h2>Mes projets</h2>
    
      <div className="container">
      
      {data.webapps.map((webapp) => (
        <Link to={`/project/${webapp.id}`}>
          <div className="item">
           <img
              src={webapp.img}
              alt=""
            />
           <h3>{webapp.title}</h3>
          </div>
          </Link>

        ))}
      </div>
    </div>
  );
}